module.exports = __webpack_public_path__ + "img/cc-paypal.ba58ff1b.svg";